import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaShopify,
  FaTools,
  FaRocket,
  FaMobileAlt,
  FaLock,
  FaThumbsUp,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const ShopifyEcommerceDevelopmentInBurDubai = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Shopify E-commerce Development in Bur Dubai" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Power Your Store with Shopify</Subheading>}
        heading={
          <Heading>
            Shopify <span tw="text-primary-500">E-commerce Development</span> in
            Bur Dubai
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we provide expert Shopify e-commerce development
            services in **Bur Dubai**, crafting customized, high-performing
            online stores on the Shopify platform. Launch your business with a
            solution that’s fast, scalable, and tailored to your needs.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1556155092-490a1ba16284?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // E-commerce website on laptop
          "https://images.unsplash.com/photo-1661956602944-249bcd04b63f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Shopify logo and brand
          "https://images.unsplash.com/photo-1577401158266-39c8a0e37d58?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Online shopping experience
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Start with Shopify"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Expert Shopify Development in Bur Dubai"
        description="We leverage Shopify’s power to deliver exceptional e-commerce solutions."
        cards={[
          {
            icon: <FaShopify color="#ff5464" size={40} />,
            title: "Shopify Expertise",
            description:
              "Certified professionals with deep platform knowledge.",
          },
          {
            icon: <FaTools color="#ff5464" size={40} />,
            title: "Custom Solutions",
            description: "Tailored themes and apps to match your brand.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Fast Setup",
            description:
              "Quickly launch your store with optimized performance.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Mobile Optimization",
            description: "Responsive designs for seamless mobile shopping.",
          },
          {
            icon: <FaLock color="#ff5464" size={40} />,
            title: "Secure & Reliable",
            description: "Built-in security features for safe transactions.",
          },
          {
            icon: <FaThumbsUp color="#ff5464" size={40} />,
            title: "Client Satisfaction",
            description: "Trusted by Bur Dubai businesses for Shopify success.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Shopify Development Process"
        description={
          <Description>
            We streamline Shopify development to deliver top-notch e-commerce
            stores:
            <ul tw="mt-4 list-disc pl-6">
              <li>Consultation: Define your goals and Shopify requirements.</li>
              <li>Design: Customize themes to reflect your brand identity.</li>
              <li>
                Development: Integrate apps and features for functionality.
              </li>
              <li>
                Testing: Ensure compatibility and performance on all devices.
              </li>
              <li>Launch: Deploy your store with full setup support.</li>
              <li>Maintenance: Provide ongoing updates and optimization.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1590935217180-77701fc6b476?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // E-commerce development process
          "https://images.unsplash.com/photo-1565106430482-8f6e74349ca1?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Team working on digital projects
          "https://images.unsplash.com/photo-1523726491678-bf852e717f6a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Product photography for e-commerce
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Shopify Success in Bur Dubai"
        description="Our Shopify expertise has driven impressive results for local businesses."
        cards={[
          {
            icon: <FaShopify color="#ff5464" size={40} />,
            title: "Sales Growth",
            description: "Boosted a retailer’s revenue by 150% with Shopify.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Rapid Launch",
            description: "Launched a custom Shopify store in under 2 weeks.",
          },
          {
            icon: <FaThumbsUp color="#ff5464" size={40} />,
            title: "Happy Clients",
            description: "98% satisfaction rate from Shopify projects.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready to Launch with Shopify?</Subheading>}
        heading="Your Shopify Store in Bur Dubai Awaits"
        description={
          <Description>
            Partner with MilaajBrandset for expert Shopify e-commerce
            development in Bur Dubai. Build a powerful, customized online store
            that grows with your business—starting today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1516321165247-4aa89a48be28?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Successful business team
          "https://images.unsplash.com/photo-1515378791036-0648a3ef77b2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Woman happily using laptop for online shopping
          "https://images.unsplash.com/photo-1561069934-eee225952461?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Dubai shopping experience
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
